import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import { DesktopSidebar } from "$/modules/shared/ui/desktop-sidebar";
import { MobileSidebar } from "$/modules/shared/ui/mobile-sidebar";

export const Route = createFileRoute("/$locale/$userId/projects/$projectId")({
	component: ProjectEditLayout,
});

function ProjectEditLayout() {
	const { pathname } = useLocation();
	const isCertificateEditor = pathname
		.replace(/\/$/, "")
		.endsWith("/certificates");

	return (
		<div className="min-h-screen md:flex">
			<DesktopSidebar />
			<MobileSidebar />
			<div className="min-w-0 flex-1 overflow-y-auto">
				<div
					className={
						isCertificateEditor
							? "w-full px-4 pb-8 pt-16 sm:px-6 md:px-10 md:pt-10 lg:px-12"
							: "mx-auto w-full max-w-[1600px] px-4 pb-8 pt-16 sm:px-6 md:px-8 md:pt-10 lg:px-10"
					}
				>
					<Outlet />
				</div>
			</div>
		</div>
	);
}
